export const default_SrcGeoJsonId = "relation/7786319"; // Library
export const default_DstGeoJsonId = "relation/7786319"; // Library
